export const EventHeroText = {
  en: {
    preTitle: "",
    name: "Business Events",
  },

  vi: {
    preTitle: "",
    name: "Sự Kiện Doanh Nghiệp",
  },
};

export const missionEventText = {
  en: {
    title: "Connect, collaborate, and grow ",

    description: "",
  },

  vi: {
    title: "Kết nối, hợp tác và phát triển",

    description: "",
  },
};

export const BusinessEventText = {
  en: {
    title: "Business Events",
    secondTitle: "Workshops",

    intro: [
      "Connect, collaborate, and grow through premium business networking and corporate events designed to inspire success.",

      "Bringing business owners, professionals, and industry leaders together to create meaningful opportunities and lasting partnerships.",

      "Professional business functions that foster networking, innovation, and business growth across New Zealand and Australia.",
    ],

    body: [
      "We design practical workshops to help SMEs move from survival to sustainable growth and success.",

      "Gain real business strategies, hands-on learning, and actionable insights from experienced industry professionals.",

      "Empowering business owners with the tools, systems, and knowledge to scale confidently and improve results.",
    ],

    links: {
      businessEvent: {
        label: "Upcoming Event",
        url: "https://sunwave.eventbrite.com/",
      },

      workshop: {
        label: "Upcoming Workshop",
        url: "https://www.eventbrite.co.nz/e/from-survival-to-scale-business-and-networking-tickets-1988894612325",
      },
    },
  },

  vi: {
    title: "Sự Kiện Doanh Nghiệp",
    secondTitle: "Workshop",

    intro: [
      "Kết nối, hợp tác và phát triển thông qua các sự kiện networking doanh nghiệp và chương trình chuyên nghiệp được thiết kế nhằm truyền cảm hứng cho thành công.",

      "Kết nối các chủ doanh nghiệp, chuyên gia và lãnh đạo trong ngành để tạo ra những cơ hội ý nghĩa và các mối quan hệ hợp tác lâu dài.",

      "Các sự kiện doanh nghiệp chuyên nghiệp thúc đẩy networking, đổi mới và tăng trưởng kinh doanh tại New Zealand và Australia.",
    ],

    highlight:
      "Những kết nối kinh doanh mạnh mẽ sẽ tạo ra nhiều cơ hội, đổi mới và thành công bền vững hơn.",

    body: [
      "Chúng tôi thiết kế các workshop thực tiễn nhằm giúp SMEs chuyển mình từ giai đoạn tồn tại sang tăng trưởng và thành công bền vững.",

      "Tiếp cận các chiến lược kinh doanh thực tế, học tập thực hành và những kiến thức có thể áp dụng ngay từ các chuyên gia giàu kinh nghiệm.",

      "Trao quyền cho chủ doanh nghiệp thông qua công cụ, hệ thống và kiến thức cần thiết để mở rộng doanh nghiệp tự tin và hiệu quả hơn.",
    ],

    links: {
      businessEvent: {
        label: "Sự Kiện Sắp Tới",
        url: "https://sunwave.eventbrite.com/",
      },

      workshop: {
        label: "Workshop Sắp Tới",
        url: "https://www.eventbrite.co.nz/e/from-survival-to-scale-business-and-networking-tickets-1988894612325",
      },
    },
  },
};

export const PrivateSectionText = {
  en: {
    title: "Private Session",

    intro: [
      "Personalised one-on-one business sessions tailored to your unique goals, challenges, and growth opportunities.",

      "Strategic private coaching and advisory sessions focused on improving performance, profitability, and business direction.",

      "Confidential business guidance designed to help you make smarter decisions and achieve measurable results faster.",
    ],

    highlight:
      "We believe every business owner deserves clear direction, practical strategies, and personalised support to achieve sustainable success.",
  },

  vi: {
    title: "Tư Vấn Riêng",

    intro: [
      "Các buổi tư vấn 1-1 được cá nhân hoá dựa trên mục tiêu, thách thức và cơ hội phát triển riêng của doanh nghiệp bạn.",

      "Các buổi coaching và cố vấn chiến lược tập trung vào việc cải thiện hiệu suất, lợi nhuận và định hướng phát triển doanh nghiệp.",

      "Các buổi tư vấn bảo mật giúp bạn đưa ra quyết định thông minh hơn và đạt được kết quả rõ ràng nhanh hơn.",
    ],

    highlight:
      "Chúng tôi tin rằng mỗi chủ doanh nghiệp đều cần có định hướng rõ ràng, chiến lược thực tiễn và sự đồng hành phù hợp để đạt được thành công bền vững.",
  },
};

export const paypal385 = "https://www.paypal.com/ncp/payment/CHZH6JXB4G32W";
export const paypal265 = "https://www.paypal.com/ncp/payment/Q6T6NEXQMM2AJ";

export const BookingSectionText = {
  en: {
    title: "Book Your Session",
    office: "Head Office",
    sessionTitle: "Enquiry Now",

    sessions: [
      {
        title: "Complimentary Business Health Check",
        top: "A focused 30-minute strategy session ",

        duration: "30 Minutes FREE",
        description: `• A complimentary session to explore your business challenges, opportunities, and growth potential.
• Discover practical strategies to improve productivity, profitability, leadership, and business performance.
• Discuss your business goals and receive expert recommendations tailored to your needs.
• A focused business review designed to uncover opportunities and support smarter decision-making.
• Helping business owners gain clarity, direction, and confidence for the next stage of growth.`,
        button: "Enquire Now",
        image: "/maria/MA/MA Sessons 30m.png",
        link: "email",
      },

      {
        title: "Business Strategy & Growth Planning",
        duration: "90 Minutes NZ$265",
        top: "A focused 90-minute strategy session designed to help businesses identify opportunities, overcome challenges, and plan for growth.",
        description: `
• Gain practical business insights, strategic direction, and actionable solutions tailored to your business goals.
• Strengthen your business foundation with smarter planning, clearer vision, and measurable growth strategies.
• Discover opportunities to improve productivity, profitability, operations, and business performance.
• Designed for SMEs, business owners, managers, and growing companies seeking clarity and direction.
• Turn business challenges into strategic opportunities with expert guidance and planning support.
• Build a stronger business with effective growth strategies, systems, and leadership planning.
• Create a clear roadmap for sustainable business growth and long-term success.
• Strategic planning today creates stronger business results tomorrow.
• Gain clarity, confidence, and a practical action plan to move your business forward.`,
        button: "Enquiry Now",
        image: "/maria/MA/MA Sessons 90m.png",

        link: paypal265,
      },

      {
        title: "Leadership & Management Development",
        duration: "120 Minutes NZ$385",
        top: "A practical 120-minute session designed to improve leadership, communication, and management effectiveness.",
        description: `
• Develop confident leaders who can drive performance, productivity, and business growth.
• Learn proven strategies to lead teams with clarity, confidence, and purpose.
• Build stronger leadership skills to improve staff performance, workplace culture, and business results.
• Transform the way you manage people, solve challenges, and lead your business forward.
• Designed for business owners, managers, supervisors, and emerging leaders.
• Practical insights and actionable strategies you can apply immediately in your workplace.
• Strong leadership creates stronger teams, better systems, and sustainable business success.
• Empower your leadership. Strengthen your business. Inspire your team.
• Invest 120 minutes to develop the leadership mindset needed for long-term growth and success.`,
        button: "Enquiry Now",
        image: "/maria/MA/MA Sessons 120m.png",

        link: paypal385,
      },
    ],
  },

  vi: {
    title: "Đặt Lịch Tư Vấn",
    office: "Trụ sở chính",
    sessionTitle: "Liên Hệ Ngay",

    sessions: [
      {
        title: "Đánh Giá Sức Khỏe Doanh Nghiệp Miễn Phí",
        duration: "30 phút MIỄN PHÍ",
        description: `• Buổi tư vấn miễn phí giúp bạn đánh giá những thách thức, cơ hội và tiềm năng phát triển của doanh nghiệp.
• Khám phá các giải pháp thực tiễn nhằm nâng cao năng suất, lợi nhuận, năng lực lãnh đạo và hiệu quả kinh doanh.
• Trao đổi về mục tiêu kinh doanh và nhận các khuyến nghị từ chuyên gia phù hợp với nhu cầu của doanh nghiệp.
• Đánh giá tổng quan để xác định các cơ hội cải thiện và hỗ trợ đưa ra những quyết định kinh doanh hiệu quả hơn.
• Giúp chủ doanh nghiệp có định hướng rõ ràng, tự tin và sẵn sàng cho giai đoạn phát triển tiếp theo.`,
        button: "Liên Hệ Ngay",
        image: "/maria/MA/MA Sessons 30m.png",

        link: "email",
      },

      {
        title: "Hoạch Định Chiến Lược & Phát Triển Doanh Nghiệp",
        duration: "90 phút NZ$265",
        top: "Buổi tư vấn chiến lược chuyên sâu kéo dài 90 phút giúp doanh nghiệp xác định cơ hội, vượt qua thách thức và xây dựng kế hoạch tăng trưởng bền vững.",
        description: `• Nhận những góc nhìn thực tiễn, định hướng chiến lược và các giải pháp phù hợp với mục tiêu kinh doanh.
• Xây dựng nền tảng doanh nghiệp vững chắc với kế hoạch rõ ràng và chiến lược tăng trưởng có thể đo lường.
• Khám phá cơ hội nâng cao năng suất, lợi nhuận, quy trình vận hành và hiệu quả kinh doanh.
• Phù hợp với doanh nghiệp vừa và nhỏ (SMEs), chủ doanh nghiệp, nhà quản lý và các doanh nghiệp đang phát triển.
• Chuyển hóa những thách thức thành cơ hội chiến lược với sự đồng hành của chuyên gia.
• Xây dựng doanh nghiệp vững mạnh hơn thông qua chiến lược tăng trưởng, hệ thống vận hành và kế hoạch phát triển đội ngũ lãnh đạo.
• Thiết lập lộ trình rõ ràng hướng đến tăng trưởng bền vững và thành công lâu dài.
• Hoạch định chiến lược hôm nay để tạo nên kết quả kinh doanh vượt trội trong tương lai.
• Có được sự rõ ràng, tự tin và kế hoạch hành động cụ thể để đưa doanh nghiệp phát triển mạnh mẽ hơn.`,
        image: "/maria/MA/MA Sessons 90m.png",

        button: "Liên Hệ Ngay",
        link: paypal265,
      },

      {
        title: "Phát Triển Năng Lực Lãnh Đạo & Quản Lý",
        duration: "120 phút NZ$385",
        top: "Buổi tư vấn thực tiễn kéo dài 120 phút nhằm nâng cao năng lực lãnh đạo, kỹ năng giao tiếp và hiệu quả quản lý trong doanh nghiệp.",
        description: `• Phát triển đội ngũ lãnh đạo tự tin, có khả năng thúc đẩy hiệu suất, năng suất và tăng trưởng doanh nghiệp.
• Học các phương pháp đã được kiểm chứng để dẫn dắt đội ngũ với sự rõ ràng, tự tin và mục tiêu rõ ràng.
• Nâng cao kỹ năng lãnh đạo nhằm cải thiện hiệu suất nhân viên, văn hóa doanh nghiệp và kết quả kinh doanh.
• Thay đổi cách quản lý con người, giải quyết vấn đề và dẫn dắt doanh nghiệp phát triển.
• Phù hợp với chủ doanh nghiệp, nhà quản lý, trưởng nhóm, giám sát và các lãnh đạo tiềm năng.
• Các giải pháp thực tiễn có thể áp dụng ngay vào môi trường làm việc.
• Lãnh đạo vững mạnh sẽ tạo nên đội ngũ mạnh, hệ thống hiệu quả và doanh nghiệp phát triển bền vững.
• Nâng tầm năng lực lãnh đạo. Phát triển doanh nghiệp. Truyền cảm hứng cho đội ngũ.
• Đầu tư 120 phút để xây dựng tư duy lãnh đạo cần thiết cho sự phát triển và thành công lâu dài.`,
        image: "/maria/MA/MA Sessons 120m.png",

        button: "Liên Hệ Ngay",
        link: paypal385,
      },
    ],
  },
};

export const networkingEvents = {
  en: {
    hero: {
      badge: "Business Networking",
      title: "Our Events ",
      highlight: "Grow Your Network",
      description:
        "Join business networking events, workshops and community gatherings designed to connect entrepreneurs, professionals and business owners throughout New Zealand.",
      button: "Browse Eventbrite",
    },
    heading: {
      subtitle: "Business Networking",
      title: "Our Up Upcoming Events",
    },
    tabs: {
      upcoming: "Upcoming",
      past: "Past",
      media: "Media",
    },

    events: [
      {
        id: 1,
        status: "Sales Ended",
        title: "Business Networking & Growth Opportunities",
        eventDate: "2026-06-26T18:00:00",

        date: "Fri, 26 Jun",
        time: "6:00 pm",
        venue: "110 Carlton Gore Road",
        price: "From $0.00",
        category: "Past",
        image: "/maria/events/media/auckland2.png",

        link: "https://www.eventbrite.co.nz/e/business-networking-growth-opportunities-tickets-1988894612325",
      },

      {
        id: 2,
        status: "Sales Ended",
        title: "Auckland Business Networking Night",

        eventDate: "2026-05-28T18:30:00",

        date: "Thu, 28 May",
        time: "6:30 pm",
        venue: "110 Carlton Gore Road",
        price: "Free",
        category: "Past",
        image: "/maria/events/media/bdi.webp",

        link: "https://www.eventbrite.co.nz/e/auckland-business-networking-night-tickets-1989193831297",
      },

      {
        id: 3,
        title: "Auckland Business Networking Night",

        eventDate: "2026-07-30T16:30:00",

        date: "Thu, 30 Jul",
        time: "4:30 pm",
        venue: "4 Williamson Avenue, Ponsonby",
        price: "From $0.00",
        category: "Upcoming",
        image: "/maria/events/media/aucklandbusiness.webp",
        link: "https://www.eventbrite.co.nz/e/auckland-business-networking-night-tickets-1990610755355",
      },
      {
        id: 4,
        title: "Business Growth & Future Talent Connect",

        eventDate: "2026-08-13T16:00:00",

        date: "Thu, 13 Aug",
        time: "4:00 pm",

        venue: "350 Queen Street, Auckland",
        organiser: "Sunwave",

        price: "Free",
        category: "Upcoming",

        image: "/maria/events/media/13Aug.webp",

        description:
          "Join BDI Network and Auckland International Campus (Otago Polytechnic & Future Skills) for an exclusive evening bringing together business owners, entrepreneurs, and emerging business professionals.",

        link: "https://www.eventbrite.co.nz/e/business-growth-future-talent-connect-tickets-1994126417796",
      },
      {
        id: 4,
        title: "Business Growth Blueprint for New Zealand SMEs",

        eventDate: "2026-08-20T14:30:00",

        date: "Thu, 20 Aug",
        time: "2:30 pm",

        venue: "Online via Teams",
        organiser: "Sunwave",

        price: "Free",
        category: "Upcoming",

        image: "/maria/events/media/business20aug.webp",

        description:
          "Join BDI Network and Auckland International Campus (Otago Polytechnic & Future Skills) for an exclusive evening bringing together business owners, entrepreneurs, and emerging business professionals.",

        link: "https://www.eventbrite.co.nz/e/business-growth-blueprint-for-new-zealand-smes-tickets-1994629469437",
      },
      {
        id: 5,
        title: "Auckland Business Networking Event",

        eventDate: "2026-08-27T18:00:00",

        date: "Thu, 27 Aug",
        time: "6:00 pm",

        venue: "c/o Fairfax Media",
        price: "From $0.00",

        image: "/maria/events/media/auckland278.png",

        link: "https://www.eventbrite.co.nz/e/auckland-business-networking-event-27826-tickets-1993299928745", // Add Eventbrite link
      },

      {
        id: 6,
        title: "BDI Business Networking & Growth Event",

        eventDate: "2026-09-24T18:00:00",

        date: "Thu, 24 Sep",
        time: "6:00 pm",

        venue: "c/o Fairfax Media",
        price: "From $0.00",

        image: "/maria/events/media/bdi249.png",

        badge: "Just Added",

        link: "https://www.eventbrite.co.nz/e/bdi-business-networking-growth-event-24926-tickets-1993305516458", // Add Eventbrite link
      },
      {
        id: 61,
        title: "TET TRUNG THU 2026",

        eventDate: "2026-09-25T18:00:00",

        date: "Thứ Sáu, 25/9",
        time: "6:00 chiều",

        venue: "Mount Albert War Memorial HallAuckland, Auckland",
        price: "Từ $0.00",

        image: "/maria/events/media/trungthu.jpg",

        badge: "Mới thêm",

        link: "https://www.eventbrite.co.nz/e/tet-trung-thu-2026-tickets-1997140626375", // Thêm link Eventbrite
      },
      {
        id: 7,
        title: "BDI Business Networking & Growth 29.10.26",

        eventDate: "2026-10-29T18:00:00",

        date: "Thu, 29 Oct",
        time: "6:00 pm",

        venue: "c/o Fairfax Media",
        price: "From $0.00",

        image: "/maria/events/media/BDI291026.png",

        link: "https://www.eventbrite.co.nz/e/bdi-business-networking-growth-291026-tickets-1994267394461", // Add Eventbrite link
      },
    ],

    mediaTitle: "Event Gallery",
    mediaDescription:
      "Highlights from previous networking events, featuring business owners, entrepreneurs, professionals, and community connections.",

    media: [
      "/maria/events/media/1.jpg",
      "/maria/events/media/2.jpg",
      "/maria/events/media/3.jpg",
      "/maria/events/media/4.jpg",
      "/maria/events/media/5.jpg",
      "/maria/events/media/6.jpg",
    ],

    link: "https://www.eventbrite.co.nz/o/sunwave-121328511812",
  },

  vi: {
    hero: {
      badge: "Kết Nối Doanh Nghiệp",
      title: "Tất cả Sự Kiện  ",
      highlight: "Mở Rộng Mạng Lưới",
      description:
        "Tham gia các sự kiện kết nối doanh nghiệp, hội thảo và hoạt động cộng đồng dành cho chủ doanh nghiệp và các chuyên gia trên khắp New Zealand.",
      button: "Xem Eventbrite",
    },
    heading: {
      subtitle: "Kết Nối Doanh Nghiệp",
      title: "Sự Kiện Doanh Nghiệp Sắp tới",
    },
    tabs: {
      upcoming: "Sắp diễn ra",
      past: "Đã diễn ra",
      media: "Thư viện ảnh",
    },

    events: [
      {
        id: 1,
        status: "Đã kết thúc",
        title: "Kết Nối Doanh Nghiệp & Cơ Hội Phát Triển",

        eventDate: "2026-06-26T18:00:00",

        date: "Thứ Sáu, 26/6",
        time: "6:00 chiều",
        venue: "110 Carlton Gore Road",
        price: "Từ $0.00",
        category: "Đã diễn ra",
        image: "/maria/events/media/auckland2.png",

        link: "https://www.eventbrite.co.nz/e/business-networking-growth-opportunities-tickets-1988894612325",
      },

      {
        id: 2,
        status: "Đã kết thúc",
        title: "Đêm Kết Nối Doanh Nghiệp Auckland",

        eventDate: "2026-05-28T18:30:00",

        date: "Thứ Năm, 28/5",
        time: "6:30 chiều",
        venue: "110 Carlton Gore Road",
        price: "Miễn phí",
        category: "Đã diễn ra",
        image: "/maria/events/media/bdi.webp",

        link: "https://www.eventbrite.co.nz/e/auckland-business-networking-night-tickets-1989193831297",
      },

      {
        id: 3,
        title: "Đêm Kết Nối Doanh Nghiệp Auckland",

        eventDate: "2026-07-30T16:30:00",

        date: "Thứ Năm, 30/7",
        time: "4:30 chiều",
        venue: "4 Williamson Avenue, Ponsonby",
        price: "Từ $0.00",
        category: "Sắp diễn ra",
        image: "/maria/events/media/aucklandbusiness.webp",

        link: "https://www.eventbrite.co.nz/e/auckland-business-networking-night-tickets-1990610755355",
      },
      {
        id: 4,
        title: "Kết Nối Tăng Trưởng Doanh Nghiệp & Nhân Tài Tương Lai",

        eventDate: "2026-08-13T16:00:00",

        date: "Thứ Năm, 13/08",
        time: "4:00 chiều",

        venue: "350 Queen Street, Auckland",
        organiser: "Sunwave",

        price: "Miễn phí",
        category: "Sắp diễn ra",

        image: "/maria/events/media/13Aug.webp",

        description:
          "Tham gia cùng BDI Network và Auckland International Campus (Otago Polytechnic & Future Skills) trong một buổi kết nối đặc biệt dành cho các chủ doanh nghiệp, doanh nhân và những chuyên gia kinh doanh trẻ đang phát triển. Đây là cơ hội để mở rộng mạng lưới, chia sẻ kinh nghiệm và khám phá những cơ hội hợp tác trong tương lai.",

        link: "https://www.eventbrite.co.nz/e/business-growth-future-talent-connect-tickets-1994126417796",
      },
      {
        id: 4,
        title: "Lộ trình Phát triển Doanh nghiệp dành cho SMEs tại New Zealand",

        eventDate: "2026-08-20T14:30:00",

        date: "Thứ Năm, 20/8",
        time: "2:30 chiều",

        venue: "Trực tuyến qua Microsoft Teams",
        organiser: "Sunwave",

        price: "Miễn phí",
        category: "Sắp diễn ra",

        image: "/maria/events/media/business20aug.webp",

        description:
          "Tham gia cùng BDI Network và Auckland International Campus (Otago Polytechnic & Future Skills) trong một buổi hội thảo trực tuyến dành riêng cho các chủ doanh nghiệp, doanh nhân và những chuyên gia kinh doanh đang phát triển. Chương trình sẽ chia sẻ các chiến lược thực tiễn giúp doanh nghiệp vừa và nhỏ (SMEs) tại New Zealand xây dựng nền tảng tăng trưởng bền vững và phát triển trong tương lai.",

        link: "https://www.eventbrite.co.nz/e/business-growth-blueprint-for-new-zealand-smes-tickets-1994629469437",
      },
      {
        id: 5,
        title: "Sự Kiện Kết Nối Doanh Nghiệp Auckland",

        eventDate: "2026-08-27T18:00:00",

        date: "Thứ Năm, 27/8",
        time: "6:00 chiều",

        venue: "c/o Fairfax Media",
        price: "Từ $0.00",

        image: "/maria/events/media/auckland278.png",

        link: "https://www.eventbrite.co.nz/e/auckland-business-networking-event-27826-tickets-1993299928745", // Thêm link Eventbrite
      },

      {
        id: 6,
        title: "Sự Kiện Kết Nối & Phát Triển Doanh Nghiệp BDI",

        eventDate: "2026-09-24T18:00:00",

        date: "Thứ Năm, 24/9",
        time: "6:00 chiều",

        venue: "c/o Fairfax Media",
        price: "Từ $0.00",

        image: "/maria/events/media/bdi249.png",

        badge: "Mới thêm",

        link: "https://www.eventbrite.co.nz/e/bdi-business-networking-growth-event-24926-tickets-1993305516458", // Thêm link Eventbrite
      },

      {
        id: 61,
        title: "TET TRUNG THU 2026",

        eventDate: "2026-09-25T18:00:00",

        date: "Thứ Sáu, 25/9",
        time: "6:00 chiều",

        venue: "Mount Albert War Memorial HallAuckland, Auckland",
        price: "Từ $0.00",

        image: "/maria/events/media/trungthu.jpg",

        badge: "Mới thêm",

        link: "https://www.eventbrite.co.nz/e/tet-trung-thu-2026-tickets-1997140626375", // Thêm link Eventbrite
      },

      {
        id: 7,
        title: "Sự Kiện Kết Nối & Phát Triển Doanh Nghiệp BDI 29.10.26",

        eventDate: "2026-10-29T18:00:00",

        date: "Thứ Năm, 29/10",
        time: "6:00 pm",

        venue: "c/o Fairfax Media",
        price: "Từ $0.00",

        image: "/maria/events/media/BDI291026.png",

        link: "https://www.eventbrite.co.nz/e/bdi-business-networking-growth-291026-tickets-1994267394461", // Add Eventbrite link
      },
    ],

    mediaTitle: "Thư Viện Hình Ảnh",
    mediaDescription:
      "Những khoảnh khắc nổi bật từ các sự kiện kết nối doanh nghiệp, nơi các chủ doanh nghiệp, doanh nhân và chuyên gia gặp gỡ, chia sẻ và mở rộng mạng lưới quan hệ.",

    media: [
      "/maria/events/media/1.jpg",
      "/maria/events/media/2.jpg",
      "/maria/events/media/3.jpg",
      "/maria/events/media/4.jpg",
      "/maria/events/media/5.jpg",
      "/maria/events/media/6.jpg",
    ],

    link: "https://www.eventbrite.co.nz/o/sunwave-121328511812",
  },
};
